import { ProductVisualizationResultMessageType } from "@redotech/redo-model/conversation/message-parsers/product-visualization-result-message-parser";
import { memo } from "react";
import { Flex } from "../../flex";
import { Text } from "../../text";

export interface ProductVisualizationResultProps {
  message: ProductVisualizationResultMessageType;
  readOnly?: boolean;
}

export const ProductVisualizationResult = memo(
  function ProductVisualizationResult({
    message,
    readOnly,
  }: ProductVisualizationResultProps) {
    const visualizationUrl = message.structuredContent?.visualizationUrl;

    if (!visualizationUrl) {
      return null;
    }

    return (
      <Flex dir="column" gap="xs" style={{ maxWidth: "400px" }} w="full">
        <img
          alt="Product visualization"
          src={visualizationUrl}
          style={{
            width: "100%",
            height: "auto",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          }}
        />
        <Text fontSize="xs" textColor="tertiary">
          AI-generated • Results may vary
        </Text>
      </Flex>
    );
  },
);
